module.exports = __webpack_public_path__ + "img/hyqy.2eae7305.jpg";